import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthState } from '@ngxs-store/auth-store/auth.state';
import { Store } from '@ngxs/store';
import { HostListener } from '@angular/core';

@Component({
    selector: 'app-shared-footer',
    templateUrl: './shared-footer.component.html',
    styleUrls: ['./shared-footer.component.css'],
    encapsulation: ViewEncapsulation.None
})


export class SharedFooterComponent {
    @Input() isHomePage: boolean = false;
    
    hasValidToken = false;
    constructor (public store: Store) {
        this.hasValidToken = this.store.selectSnapshot(AuthState.getHasValidToken);
    }

    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    
    isScrolling: boolean = false;

    @HostListener('window:scroll')
    onScroll() {
      this.isScrolling = window.pageYOffset > 0;
    }
}
